var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTmv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_452",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 28,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 3.64001H0V24.64H28V3.64001Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.39 6.16001H11.97V3.85001C11.97 3.73409 12.0641 3.64001 12.18 3.64001C12.2959 3.64001 12.39 3.73409 12.39 3.85001V6.16001Z",
    fill: "#A5A9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.58 6.71998H10.78C10.78 6.10146 11.2815 5.59998 11.9 5.59998H12.46C13.0785 5.59998 13.58 6.10146 13.58 6.71998Z",
    fill: "#A5A9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.39 6.16001H11.97V3.85001C11.97 3.73409 12.0641 3.64001 12.18 3.64001C12.2959 3.64001 12.39 3.73409 12.39 3.85001V6.16001Z",
    fill: "#858889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.18 3.64001C12.0641 3.64001 11.97 3.73409 11.97 3.85001V6.16001H12.39V3.85001C12.39 3.73409 12.2959 3.64001 12.18 3.64001Z",
    fill: "#858889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.58 6.71998H10.78C10.78 6.10146 11.2815 5.59998 11.9 5.59998H12.46C13.0785 5.59998 13.58 6.10146 13.58 6.71998Z",
    fill: "#858889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.46 5.87998C12.8251 5.87998 13.1365 6.11406 13.2521 6.43998H11.1082C11.2238 6.11406 11.5352 5.87998 11.9003 5.87998H12.46ZM12.46 5.59998H11.9C11.2815 5.59998 10.78 6.10146 10.78 6.71998H13.58C13.58 6.10146 13.0785 5.59998 12.46 5.59998Z",
    fill: "#858889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.18 16.24C14.9635 16.24 17.22 13.9835 17.22 11.2C17.22 8.41646 14.9635 6.15997 12.18 6.15997C9.3965 6.15997 7.14001 8.41646 7.14001 11.2C7.14001 13.9835 9.3965 16.24 12.18 16.24Z",
    fill: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.78 11.3405C10.6529 8.64582 11.2627 6.43354 12.18 6.16894C12.1517 6.16894 12.1234 6.16362 12.0949 6.16614C10.915 6.2745 10.0736 8.51982 10.08 11.3405H10.78Z",
    fill: "#858889"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.58 11.3405C13.7071 8.64582 13.0973 6.43354 12.18 6.16894C12.2083 6.16894 12.2366 6.16362 12.2651 6.16614C13.445 6.2745 14.2864 8.51982 14.28 11.3405H13.58Z",
    fill: "#858889"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2692 11.228C15.2692 11.2596 15.267 11.2901 15.2667 11.3215H15.9566C15.9569 11.2901 15.9597 11.2596 15.9597 11.228C15.9597 8.44814 14.518 6.1947 12.7397 6.1947C12.733 6.1947 12.7266 6.1961 12.7198 6.19638C14.1291 6.21346 15.2692 8.45878 15.2692 11.228Z",
    fill: "#858889"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.09075 11.228C9.09075 11.2596 9.09299 11.2901 9.09327 11.3215H8.40335C8.40307 11.2901 8.40027 11.2596 8.40027 11.228C8.40027 8.44814 9.84199 6.1947 11.6203 6.1947C11.627 6.1947 11.6334 6.1961 11.6401 6.19638C10.2309 6.21346 9.09075 8.45878 9.09075 11.228Z",
    fill: "#858889"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.32 17.64H5.03998V21.84H19.32V17.64Z",
    fill: "#CFD3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.32 21.28H5.03998V22.4H19.32V21.28Z",
    fill: "#858889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08402 20.86H6.35602V18.83C6.35602 18.6368 6.51282 18.48 6.70602 18.48H6.73402C6.92722 18.48 7.08402 18.6368 7.08402 18.83V20.86Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90012 20.86H8.17212V18.83C8.17212 18.6368 8.32892 18.48 8.52212 18.48H8.55012C8.74332 18.48 8.90012 18.6368 8.90012 18.83V20.86Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7162 20.86H9.98816V18.83C9.98816 18.6368 10.145 18.48 10.3382 18.48H10.3662C10.5594 18.48 10.7162 18.6368 10.7162 18.83V20.86Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5325 20.86H11.8045V18.83C11.8045 18.6368 11.9613 18.48 12.1545 18.48H12.1825C12.3757 18.48 12.5325 18.6368 12.5325 18.83V20.86Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3486 20.86H13.6206V18.83C13.6206 18.6368 13.7774 18.48 13.9706 18.48H13.9986C14.1918 18.48 14.3486 18.6368 14.3486 18.83V20.86Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1646 20.86H15.4366V18.83C15.4366 18.6368 15.5934 18.48 15.7866 18.48H15.8146C16.0078 18.48 16.1646 18.6368 16.1646 18.83V20.86Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9807 20.86H17.2527V18.83C17.2527 18.6368 17.4095 18.48 17.6027 18.48H17.6307C17.8239 18.48 17.9807 18.6368 17.9807 18.83V20.86Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.92 12.6H6.44V16.24H17.92V12.6Z",
    fill: "#CFD3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.92 16.1H6.44V17.22H17.92V16.1Z",
    fill: "#858889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11998 15.68H7.41998V14.07C7.41998 13.8768 7.57678 13.72 7.76998 13.72C7.96318 13.72 8.11998 13.8768 8.11998 14.07V15.68Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88988 15.68H9.18988V14C9.18988 13.8454 9.31532 13.72 9.46988 13.72H9.60988C9.76444 13.72 9.88988 13.8454 9.88988 14V15.68Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6598 15.68H10.9598V14.07C10.9598 13.8768 11.1166 13.72 11.3098 13.72C11.503 13.72 11.6598 13.8768 11.6598 14.07V15.68Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4294 15.68H12.7294V14.07C12.7294 13.8768 12.8862 13.72 13.0794 13.72C13.2726 13.72 13.4294 13.8768 13.4294 14.07V15.68Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1993 15.68H14.4993V14.07C14.4993 13.8768 14.6561 13.72 14.8493 13.72C15.0425 13.72 15.1993 13.8768 15.1993 14.07V15.68Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9691 15.68H16.2691V14.07C16.2691 13.8768 16.4259 13.72 16.6191 13.72C16.8123 13.72 16.9691 13.8768 16.9691 14.07V15.68Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.92 12.32H6.44V11.76C6.44 11.4506 6.6906 11.2 7 11.2H17.36C17.6694 11.2 17.92 11.4506 17.92 11.76V12.32Z",
    fill: "#858889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.92 12.18H6.44V13.3H17.92V12.18Z",
    fill: "#858889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2 11.76H6.15998C5.8507 11.76 5.59998 12.0107 5.59998 12.32C5.59998 12.6293 5.8507 12.88 6.15998 12.88H18.2C18.5093 12.88 18.76 12.6293 18.76 12.32C18.76 12.0107 18.5093 11.76 18.2 11.76Z",
    fill: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2 12.88H15.4L16.52 11.76H18.2C18.5094 11.76 18.76 12.0106 18.76 12.32C18.76 12.6294 18.5094 12.88 18.2 12.88Z",
    fill: "#BABEBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2 11.76H16.52L15.4 12.88H18.2C18.5094 12.88 18.76 12.6294 18.76 12.32C18.76 12.0106 18.5094 11.76 18.2 11.76Z",
    fill: "#BABEBF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.32 16.968H5.03998V18.088H19.32V16.968Z",
    fill: "#858889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.18 16.52H5.18C4.87072 16.52 4.62 16.7707 4.62 17.08C4.62 17.3893 4.87072 17.64 5.18 17.64H19.18C19.4893 17.64 19.74 17.3893 19.74 17.08C19.74 16.7707 19.4893 16.52 19.18 16.52Z",
    fill: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3257 17.1985L16.5628 16.9613H19.18C19.2452 16.9613 19.2984 17.0145 19.2984 17.0797C19.2984 17.145 19.2452 17.1982 19.18 17.1982L16.3257 17.1985Z",
    fill: "#BABEBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.18 16.52H16.38L15.26 17.64H19.18C19.4894 17.64 19.74 17.3894 19.74 17.08C19.74 16.7706 19.4894 16.52 19.18 16.52Z",
    fill: "#BABEBF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.16 22.4H4.20001V24.64H20.16V22.4Z",
    fill: "#CFD3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.16 22.12H4.20001V23.24H20.16V22.12Z",
    fill: "#858889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3 21.7H4.06C3.75072 21.7 3.5 21.9507 3.5 22.26C3.5 22.5693 3.75072 22.82 4.06 22.82H20.3C20.6093 22.82 20.86 22.5693 20.86 22.26C20.86 21.9507 20.6093 21.7 20.3 21.7Z",
    fill: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0457 22.3785L16.2829 22.1413H20.3C20.3653 22.1413 20.4185 22.1945 20.4185 22.2597C20.4185 22.325 20.3653 22.3782 20.3 22.3782L16.0457 22.3785Z",
    fill: "#BABEBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3 21.7H16.1L14.98 22.82H20.3C20.6094 22.82 20.86 22.5694 20.86 22.26C20.86 21.9506 20.6094 21.7 20.3 21.7Z",
    fill: "#BABEBF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.7679 23.0477C24.5174 21.2981 24.5174 18.4617 22.7679 16.7122C21.0183 14.9626 18.1817 14.9626 16.4321 16.7122C14.6826 18.4617 14.6826 21.2981 16.4321 23.0477C18.1817 24.7972 21.0183 24.7972 22.7679 23.0477Z",
    fill: "#14A5DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4091 21.6576L15.9901 21.2416L18.2256 18.96L18.6446 19.379L16.4091 21.6576ZM18.2314 21.6576L15.9959 19.379L16.4149 18.96L18.6503 21.2416L18.2314 21.6576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.354 19.9876V20.5386H18.8359V19.9876H20.354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3667 20.0006V19.5746H21.8536C22.0831 19.5746 22.2789 19.6068 22.4411 19.6715C22.6034 19.7361 22.7357 19.8249 22.8379 19.9377C22.94 20.0506 23.0149 20.1792 23.0623 20.3234C23.1099 20.4676 23.1335 20.6204 23.1335 20.7817C23.1335 21.001 23.1007 21.1964 23.0354 21.3675C22.9701 21.5385 22.8771 21.6832 22.757 21.8016C22.6369 21.92 22.4965 22.0092 22.3361 22.0693C22.1757 22.1295 22.0012 22.1598 21.813 22.1598C21.6445 22.1598 21.4832 22.1318 21.329 22.0757C21.1747 22.0198 21.0367 21.9364 20.9149 21.8257C20.7929 21.715 20.6967 21.5761 20.6258 21.4093C20.5548 21.2427 20.5196 21.0494 20.5196 20.8301H21.1677C21.1677 20.97 21.195 21.0931 21.2496 21.1996C21.3042 21.306 21.3814 21.3894 21.4809 21.4496C21.5803 21.5097 21.6946 21.5398 21.8237 21.5398C21.96 21.5398 22.0773 21.5108 22.1759 21.4528C22.2745 21.3948 22.3502 21.3086 22.4031 21.1947C22.456 21.0807 22.4824 20.9429 22.4824 20.7817C22.4824 20.5988 22.4528 20.4503 22.3937 20.3362C22.3346 20.2223 22.2501 20.1378 22.1409 20.0828C22.0315 20.028 21.9024 20.0004 21.7537 20.0004H21.3665L21.3667 20.0006ZM21.3667 19.3939H21.7539C21.9045 19.3939 22.0295 19.3628 22.1292 19.3003C22.2286 19.238 22.3026 19.1518 22.351 19.0422C22.3995 18.9323 22.4236 18.8066 22.4236 18.6646C22.4236 18.5161 22.4016 18.3887 22.3577 18.2823C22.3137 18.1756 22.2474 18.0935 22.1586 18.0354C22.0699 17.9774 21.9572 17.9482 21.8211 17.9482C21.7064 17.9482 21.6029 17.9757 21.5105 18.0305C21.4181 18.0854 21.3452 18.1628 21.2912 18.2629C21.2375 18.3629 21.2106 18.4817 21.2106 18.6193H20.5597C20.5597 18.3699 20.6143 18.1483 20.7238 17.9546C20.8332 17.7609 20.9823 17.6088 21.1715 17.4978C21.3605 17.3871 21.5734 17.3317 21.8102 17.3317C22.063 17.3317 22.2841 17.3816 22.4731 17.4816C22.6623 17.5817 22.8097 17.7306 22.9155 17.9286C23.0213 18.1265 23.0742 18.3719 23.0742 18.6643C23.0742 18.7977 23.0482 18.9334 22.9961 19.071C22.9441 19.2088 22.8671 19.334 22.7649 19.4468C22.6627 19.5597 22.5354 19.6512 22.3828 19.7212C22.2305 19.7912 22.0539 19.8261 21.8531 19.8261H21.3663V19.3937L21.3667 19.3939Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmv);
export default __webpack_public_path__ + "static/media/TMV.61c0b7fcae90ed2ed75291ef726ce611.svg";
export { ForwardRef as ReactComponent };